// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_q3-0";
export var animationContainer = "_q3-1";
export var itemPrice = "_q3-a";
export var itemizedContent = "_q3-9";
export var itemizedHeader = "_q3-7";
export var itemizedRow = "_q3-8";
export var itemizedSection = "_q3-6";
export var modalContent = "_q3-2";
export var orderName = "_q3-3";
export var refundOption = "_q3-4";
export var refundOptionsContainer = "_q3-5";
export var shippingLabel = "_q3-b";
export var totalRow = "_q3-c";